import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

function LandingButton({ className, samePage, text, to, variant }) {
  if (samePage)
    return (
      <a
        href={`#${to}`}
        className={`action-button action-button--landing action-button--${variant} ${className}`}
      >
        <span className="action-button__text action-button-text">{text}</span>
      </a>
    )

  return (
    <Link
      to={to}
      className={`action-button action-button--landing action-button--${variant} ${className}`}
    >
      <span className="action-button__text action-button-text">{text}</span>
    </Link>
  )
}

LandingButton.propTypes = {
  className: PropTypes.string,
  samePage: PropTypes.bool,
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired
}

LandingButton.defaultProps = {
  className: '',
  samePage: false
}

export default memo(LandingButton)
